// interface of object for tracking device properties
export interface TrackDeviceProperties {
  source: string;
  type: string;
  osName: string;
  osVersion: string;
  browserName: string;
  browserVersion: string;
  brand: string;
  model: string;
}

export interface TrackOption {
  key: string;
  value: string;
}

export interface PreviousPageViewData {
  time: number;
  pathName: string;
}

export const SOURCE_PRODUCT = 'WEBSITE';
